export function formatNumber(number) {
    if (number >= 1000000) {
      // Convert to millions
      return Math.floor(number / 1000000) + "M+";
    } else if (number >= 1000) {
      // Convert to thousands
      return Math.floor(number / 1000) + "K+";
    }
    // Return as is if less than 1000
    return number.toString();
  }